import {
  CALC_CLIENT_GET_REQUEST,
  CALC_CLIENT_GET_SUCCESS,
  CALC_CLIENT_GET_FAILURE,
  CALC_CLIENT_CREATE_REQUEST,
  CALC_CLIENT_CREATE_SUCCESS,
  CALC_CLIENT_CREATE_FAILURE
} from "../actions";

export default function client(state = { loading: true }, action) {
  switch (action.type) {
    case CALC_CLIENT_GET_REQUEST:
      return { loading: true };
    case CALC_CLIENT_GET_SUCCESS:
      return { loading: false, ...action.data };
    case CALC_CLIENT_GET_FAILURE:
      return { error: action.error };
    case CALC_CLIENT_CREATE_REQUEST:
      return { loading: true };
    case CALC_CLIENT_CREATE_SUCCESS:
      return { loading: false, ...action.data };
    case CALC_CLIENT_CREATE_FAILURE:
      return { error: action.error };
    default:
      return state;
  }
}
